<template>
    <div class="footer-sale-box-wrapper h-spc51 md:h-spc51 sm:h-spc74 overflow-hidden bg-primaryColor fixed bottom-0 left-0 w-full" id="footer-sale-box">

    </div>
</template>

<script>
    export default {
        name: "FooterSaleBox",
        data() {
            return {
            }
        }
    }
</script>

<style scoped>

</style>